import { NgModule } from '@angular/core';

import { ErrorHandler } from './error-handler';

@NgModule({
    imports: [],
    declarations: [],
    providers: [ErrorHandler],
    exports: [
    ]
})
export class RestApiModule { }



// WEBPACK FOOTER //
// ./src/app/restapi/restapi.module.ts